<template>
  <v-menu
    v-model="ativador_menu"
    open-on-hover
    left
    offset-y
    transition="slide-y-transition"
    open-delay="500"
    close-delay="500"
    close-on-click
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="ativador" :on="on" :attrs="attrs">
        <v-btn v-show="!ocultar" v-bind="attrs" v-on="on" icon @click.stop>
          <v-icon>mdi-cube-scan</v-icon>
        </v-btn>
      </slot>
    </template>

    <div class="div-menu">
      <div class="px-3 pb-1 pt-2 d-flex align-center">
        <v-icon small>mdi-alert</v-icon>
        <span class="font-weight-medium font-13 pl-1">Alerta</span>

        <v-spacer />

        <v-btn icon x-small @click="ativador_menu = false">
          <v-icon size="16">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>

      <div class="mx-3 py-2">
        <p class="mb-2 font-weight-medium">
          Quantidade sugerida ({{ formatarNumero(valor_model) }}) inferior
          {{ ativo_estetico_por_pp ? 'a sugestão estética' : 'ao estoque estético' }}
          ({{ formatarNumero(estoque_minimo) }})
        </p>

        <div>
          <span>{{ `Manter quantidade sugerida (${formatarNumero(valor_model)})` }}</span>
          <v-btn x-small rounded color="#043554" dark class="ml-2" @click="aplicarValor(valor_model)">
            aplicar
          </v-btn>
        </div>

        <div class="mt-2">
          <span>
            Comprar
            {{ ativo_estetico_por_pp ? 'sugestão estética' : 'estoque estético' }}
            ({{ formatarNumero(SUGESTAO_ESTETICA) }})
          </span>

          <v-btn x-small rounded color="#043554" dark class="ml-2" @click="aplicarValor(SUGESTAO_ESTETICA)">
            aplicar
          </v-btn>
        </div>
      </div>
    </div>
  </v-menu>
</template>

<script>
import {formatarValor} from "@/helpers";

export default {
  name: "SurgestaoEstoqueEstetico",
  model: {
    prop: "valor_model",
    event: "change",
  },
  props: {
    valor_model: {
      type: [Number, String],
      required: true,
    },
    estoque_minimo: {
      type: [Number, String],
      required: true,
    },
    estoque: {
      type: [Number, String],
      required: true,
    },
    estoque_transito: {
      type: [Number, String],
      required: true,
    },
    ocultar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ativador_menu: false,
      ativo_estetico_por_pp: localStorage.estetico_por_pp === 'S',
    };
  },
  computed: {
    SUGESTAO_ESTETICA() {
      return Number(this.estoque_minimo) - (Number(this.estoque_transito) + Number(this.estoque));
    }
  },
  methods: {
    formatarNumero: formatarValor,
    aplicarValor(valor) {
      this.$emit('change', valor);
      this.ativador_menu = false;
    }
  }
};
</script>

<style scoped>
.div-menu {
  background: #ffffff;
  font-size: 12.5px;
}
</style>
